<template>
<div class="wide-grid">
  <RoomSelectWithTimetable
    class="room-box"
    :style="style"
    v-for="room in rooms"
    :key="room.id"
    :date="date"
    :roomId="room.id">
  </RoomSelectWithTimetable>
</div>
</template>

<script>

import { mapGetters } from 'vuex';

import RoomSelectWithTimetable from '@/components/RoomSelectWithTimetable'

import Booking from './../store/modules/booking/types'

export default {
  name: 'RoomSelectWideGrid',
  props: ['cols', 'date', 'rooms'],
  components: { RoomSelectWithTimetable },
  computed: {
    style () {
      const totalCols = Math.min(this.cols, this.rooms.length)
      const divisor = totalCols || 1;
      const width = (100 / divisor) + '%';
      return { width }
    },
    ...mapGetters('Booking', [Booking.getters.GET_BOOKINGS_BY_ROOM])
  },
}
</script>

<style lang="scss" scoped>

@import 'src/color.scss';

.wide-grid {
  display: flex;
  flex-flow: row wrap;
  width: 100%;
  margin: 0 auto;
}

.room-box {
  width: 100%;
  // float: left;
  margin-bottom: 1em;
}

</style>



// WEBPACK FOOTER //
// src/components/RoomSelectWideGrid.vue